(function () {
  function quantityForValue(value) {
    if (!value) return 1;
    if (value.indexOf('Conform') !== -1) return 6;
    if (value.indexOf('Duo') !== -1) return 2;
    return 1;
  }

  function getSelectedFormatValue(productInfo) {
    var checkedRadio = productInfo.querySelector('input[data-option-name="Format"]:checked');
    if (checkedRadio) return checkedRadio.value;

    var select = productInfo.querySelector('select[name="options[Format]"]');
    if (select) return select.value;

    return null;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.classList || !form.classList.contains('form')) return;

      var productInfo = form.closest('product-info');
      if (!productInfo) return;

      var quantity = quantityForValue(getSelectedFormatValue(productInfo));

      var input = form.querySelector('[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        form.appendChild(input);
      }
      input.value = quantity;
    },
    true
  );
})();
